module.exports = __webpack_public_path__ + "img/1.0bab8ba4.png";